/* eslint-disable eqeqeq */
import { Alert, Box, Button, Heading, Icon, Textarea } from "@chakra-ui/react";
import * as React from "react";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import MessageDialog from "../Message/Message";
import { IBodyshopService } from "../UserService";
import "./EstimateFeedback.css";
import { JobEstimationDetail } from "../modals/JobEstimationDetail";
const feedbackSuccess =
    require("./../assets/images/feedbackSuccess.png").default,
  star = require("./../assets/images/ratingStar.svg").default,
  absolutelyImage = require("./../assets/images/Absolutely.png").default,
  noThanksImage = require("./../assets/images/noThanks.png").default;
const iconDefinately = require("./../assets/images/iconDefinately.png").default,
  feedbackSad = require("./../assets/images/FeedbackSad.png").default;
export interface IAdditionalButton {
  name: string;
  key: string;
}
export interface IEstimateFeedbackProps {
  navigateToScreen: (key: string) => void;
  ibsService: IBodyshopService;
  estimateDetails: JobEstimationDetail;
  showHideLoader: (value: boolean) => void;
}

export interface IEstimateFeedbackState {
  ratings: number;
  showAdditionalButtons: boolean;
  showFeedbackSuccessMessage: boolean;
  gtSec1: string;
  gtSec2: string;
  description: string;
  ltSec1: string;
  gtSec3: string;
}
export enum additionalFeedbackButton {
  Absolutely = 1,
  noThanks = 2,
}

export default class EstimateFeedback extends React.Component<
  IEstimateFeedbackProps,
  IEstimateFeedbackState
> {
  private ratings = [
    { ratings: 1, image: star },
    { ratings: 2, image: star },
    { ratings: 3, image: star },
    { ratings: 4, image: star },
    { ratings: 5, image: star },
  ];
  greateThan3First: IAdditionalButton[] = [
    {
      name: "Staff showed genuine care\nand concern",
      key: "Staff showed genuine care\nand concern",
    },
    {
      name: "Communication was faultless ",
      key: "Communication was faultless",
    },
    {
      name: "The quality of work was top notch",
      key: "The quality of work was top notch",
    },
    { name: "Everything was seamless", key: "Everything was seamless" },
  ];
  greateThan3Second: IAdditionalButton[] = [
    {
      name: "Communication and response rate",
      key: "Communication and response rate",
    },
    { name: "Access to information", key: "Access to information" },
    { name: "Repair quality", key: "Repair quality" },
    { name: "Location and accessibility", key: "ocation and accessibility" },
    {
      name: "Social media and online experience",
      key: "Social media and online experience",
    },
    { name: "Online quoting", key: "Online quoting" },
    { name: "Customer Portal", key: "Customer Portal" },
  ];
  lessThan2First: IAdditionalButton[] = [
    { name: "Customer service", key: "Customer service" },
    {
      name: "Communication and response rate",
      key: "Communication and response rate",
    },
    { name: "Repair quality", key: "Repair quality" },
    { name: "Reception area", key: "Reception area" },
    { name: "Social media channels", key: "Social media channels" },
    { name: "Website", key: "Website" },
    { name: "Online quoting", key: "Online quoting" },
    { name: "Customer Portal experience", key: "Customer Portal experience" },
  ];
  constructor(props: IEstimateFeedbackProps) {
    super(props);

    this.state = {
      gtSec1: "",
      gtSec2: "",
      gtSec3: "",
      ltSec1: "",
      description: "",
      ratings: 0,
      showAdditionalButtons: false,
      showFeedbackSuccessMessage: false,
    };
  }
  renderAdditionalFeedbackButtons() {
    let buttons = [
      {
        name: "Absolutely!",
        key: additionalFeedbackButton.Absolutely,
        image: absolutelyImage,
        onClick: () => this.setState({ showAdditionalButtons: true }),
      },
      {
        name: "No thanks.",
        key: additionalFeedbackButton.noThanks,
        image: noThanksImage,
        onClick: () => this.setState({ showFeedbackSuccessMessage: true }),
      },
    ];
    return (
      <div className={"row"}>
        {buttons.map((e) => (
          <div className={"col-6"} onClick={(ev) => e.onClick()} key={e.key}>
            <div className={"hireButton"}>
              <img src={e.image} alt="Hire Button" />
              <span className={"hireText"}>{e.name}</span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  getSuccessImage() {
    return this.state.ratings >= 4 ? feedbackSuccess : feedbackSad;
  }
  getSuccessTitle() {
    return this.state.ratings >= 4 ? "Thank You!" : "Oh no...";
  }
  getSuccessMessageText() {
    return this.state.ratings >= 4
      ? "Your feedback means a lot to us.\n\nOh and by the way, you can access your referral\nlink anytime in the FlowGetter tab\non the Home Menu."
      : "We’re truly sorry your repair experience didn’t meet your expectations.\n\nWe appreciate all the feedback you’ve shared, it’ll definitely help us improve our service.";
  }
  public render(): React.ReactElement<IEstimateFeedbackProps> {
    return (
      <Box>
        {this.state.showFeedbackSuccessMessage ? (
          <MessageDialog
            closeCallback={() => this.props.navigateToScreen("home")}
            icon={<img src={this.getSuccessImage()} alt="Success" />}
            title={this.getSuccessTitle()}
            messageText={this.getSuccessMessageText()}
            buttons={
              <button
                type="button"
                onClick={() => this.props.navigateToScreen("home")}
              >
                Return To Home
              </button>
            }
          />
        ) : undefined}
        <Box>
          <Heading color={"blue.700"} size="md">
            Rate your Repair Experience Here
          </Heading>
          <Box boxShadow={"md"} borderRadius="md" overflow={"hidden"} mt={6}>
            <Heading
              size="sm"
              p={4}
              color="white"
              w="100%"
              bg="blue.700"
              display={"flex"}
              justifyContent="space-between"
            >
              How would you rate your Flow Repair Experience?
            </Heading>
            <Box
              display={"flex"}
              p={4}
              alignContent="center"
              justifyContent={"center"}
            >
              {this.ratings.map((e) => {
                return (
                  <Button
                    key={Math.random()}
                    variant="ghost"
                    onClick={() => this.setState({ ratings: e.ratings })}
                  >
                    {e.ratings <= this.state.ratings ? (
                      <Icon color={"blue.400"} as={AiFillStar} w={12} h={12} />
                    ) : (
                      <Icon
                        color={"blue.400"}
                        as={AiOutlineStar}
                        w={12}
                        h={12}
                      />
                    )}
                  </Button>
                );
              })}
            </Box>
          </Box>
          {this.state.ratings >= 1 ? this.renderAdditionalButtons() : undefined}
        </Box>
      </Box>
    );
  }
  renderAdditionalButtons() {
    if (this.state.ratings >= 4) {
      return this.renderRatingGreaterThan3();
    } else {
      return this.renderRatingsLessThan3();
    }
  }
  renderRatingGreaterThan3() {
    return (
      <Box>
        <Box boxShadow={"md"} borderRadius="md" overflow={"hidden"} mt={6}>
          <Heading
            size="sm"
            p={4}
            color="white"
            w="100%"
            bg="blue.700"
            display={"flex"}
            justifyContent="space-between"
          >
            Which of these best describe your repair experience?
          </Heading>

          {this.renderTileButtons(
            this.greateThan3First,
            this.state.gtSec1,
            (val) => {
              this.setState({ gtSec1: val.key });
            }
          )}
        </Box>

        {this.state.gtSec1 ? (
          <>
            <Box boxShadow={"md"} borderRadius="md" overflow={"hidden"} mt={6}>
              <Heading
                size="sm"
                p={4}
                color="white"
                w="100%"
                bg="blue.700"
                display={"flex"}
                justifyContent="space-between"
              >
                What would you say were the highlights of your experience? (You
                can pick more than 1)
              </Heading>

              {this.renderTileButtons(
                this.greateThan3Second,
                this.state.gtSec2,
                (val) => {
                  this.setState({ gtSec2: val.key });
                }
              )}
            </Box>
            {this.state.gtSec2 ? (
              <>
                {this.renderDescriptionBox()}
                {this.state.description ? (
                  <>
                    <Box
                      boxShadow={"md"}
                      borderRadius="md"
                      overflow={"hidden"}
                      mt={6}
                    >
                      <Heading
                        size="sm"
                        p={4}
                        color="white"
                        w="100%"
                        bg="blue.700"
                        display={"flex"}
                        justifyContent="space-between"
                      >
                        Would you recommend us to friends and family?
                      </Heading>
                      {this.renderFriendFamilyButtons()}
                    </Box>
                    {this.state.gtSec3 ? (
                      <>
                        <Box mt={6}>
                          <Alert status="info">
                            Thank you! You now have a referral link you can
                            share available on your Rewards. You and your
                            referee get 10% off you next repair when you use the
                            link!
                          </Alert>
                          {this.renderFooterButtons()}
                        </Box>
                      </>
                    ) : undefined}
                  </>
                ) : undefined}
              </>
            ) : undefined}
          </>
        ) : undefined}
      </Box>
    );
  }
  renderFriendFamilyButtons() {
    let buttons = [
      { name: "Nope", image: noThanksImage, key: "Nope" },
      { name: "Definitely", image: iconDefinately, key: "Definitely" },
    ];
    return (
      <Box display="flex" gap={4} mt={4} p={4}>
        {buttons.map((e) => (
          <Button
            w={"100%"}
            colorScheme={"cyan"}
            variant={e.key == this.state.gtSec3 ? "solid" : "outline"}
            bg={e.key == this.state.gtSec3 ? "cyan.300" : ""}
            size={"lg"}
            onClick={(ev) => this.setState({ gtSec3: e.key })}
          >
            <img src={e.image} alt="Hire Button" />
            <span>{e.name}</span>
          </Button>
        ))}
      </Box>
    );
  }
  renderFooterButtons() {
    return (
      <Box
        gap={4}
        mt={6}
        display={"flex"}
        flexFlow={"wrap"}
        justifyContent="space-between"
      >
        <Button
          size="lg"
          colorScheme="red"
          variant="outline"
          onClick={() => this.saveAndCancel()}
        >
          Cancel
        </Button>
        <Button size="lg" colorScheme="green" onClick={() => this.submit()}>
          Submit
        </Button>
        {this.state.ratings > 3 ? (
          <Button
            w={"100%"}
            size="lg"
            colorScheme="blue"
            onClick={(e) => {
              e.preventDefault();
              window.open("https://g.page/r/CTR3AZUiWYcHEAg/review", "_blank");
            }}
          >
            Share with Google
          </Button>
        ) : null}
      </Box>
    );
  }
  saveAndCancel() {
    this.props.navigateToScreen("home");
  }

  submit() {
    this.props.showHideLoader(true);
    let obj = {
      EstimateId: this.props.estimateDetails.estimateId,
      Rating: this.state.ratings,
      BestDescribe: this.state.gtSec1,
      HighlightofExpeciance: this.state.gtSec2,
      IsRecommentUS: this.state.gtSec3 == "Definitely",
      ImproveOn: this.state.ltSec1,
      Remark: this.state.description,
      JobNumber: this.props.estimateDetails.estimateId,
    };
    let msg = "Estimate Feedback \n---------------------------- \n";
    msg += "Rating : " + this.state.ratings + " \n";
    if (this.state.ratings >= 3) {
      msg += "Best Describe Rating Experiance : " + this.state.gtSec1 + " \n";
      msg += "Highlight Of Experiance : " + this.state.gtSec2 + " \n";
      msg += "Description : " + this.state.description + " \n";
      msg += "Is Recommend Us : " + (this.state.gtSec3 == "Definitely") + " \n";
    } else {
      msg += "Best Describe Rating Experiance : " + this.state.ltSec1 + " \n";
      msg += "Description : " + this.state.description + " \n";
    }
    msg +=
      "Job Number : " + this.props.estimateDetails.jobNumber + " \n";
    msg += "Estimate Id : " + this.props.estimateDetails.estimateId;

    this.props.ibsService
      .addNotes(this.props.estimateDetails.estimateId, {
        Note: msg,
        IsImportant: true,
      })
      .then((res) => {
        if (res.ok) {
          res.json().then((resJSON) => {
            this.props.ibsService.addCompleteFeedback(obj).then((res) => {
              if (res.ok) {
                res.json().then((resJSON) => {
                  if (resJSON.IsSuccess) {
                    this.props.showHideLoader(false);
                    this.setState({ showFeedbackSuccessMessage: true });
                  }
                });
              }
            });
          });
        }
      });
  }

  renderDescriptionBox() {
    return (
      <Box boxShadow={"md"} borderRadius="md" overflow={"hidden"} mt={6}>
        <Heading
          size="sm"
          p={4}
          color="white"
          w="100%"
          bg="blue.700"
          display={"flex"}
          justifyContent="space-between"
        >
          Anything else you’d like to add?
        </Heading>
        <Box p={4}>
          <Textarea
            value={this.state.description}
            onChange={(e) =>
              this.setState({ description: e.currentTarget.value })
            }
          />
        </Box>
      </Box>
    );
  }
  renderRatingsLessThan3() {
    return (
      <div>
        <Box boxShadow={"md"} borderRadius="md" overflow={"hidden"} mt={6}>
          <Heading
            size="sm"
            p={4}
            color="white"
            w="100%"
            bg="blue.700"
            display={"flex"}
            justifyContent="space-between"
          >
            Which of these best describe your repair experience?
          </Heading>

          {this.renderTileButtons(
            this.lessThan2First,
            this.state.ltSec1,
            (val) => {
              this.setState({ ltSec1: val.key });
            }
          )}
        </Box>
        {this.state.ltSec1 ? (
          <>
            {this.renderDescriptionBox()}
            {this.state.description ? this.renderFooterButtons() : undefined}
          </>
        ) : undefined}
      </div>
    );
  }
  renderTileButtons(
    buttons: IAdditionalButton[],
    selectedKey: string,
    onClick: (val: IAdditionalButton) => void
  ) {
    return (
      <Box p={4}>
        {buttons.map((e) => (
          <Button
            w="100%"
            key={e.key}
            variant={selectedKey == e.key ? "solid" : "outline"}
            onClick={(ev) => onClick(e)}
          >
            {e.name}
          </Button>
        ))}
      </Box>
    );
  }
  getAdditionalButtonText() {
    return this.state.ratings >= 4
      ? "Which of these best describe your repair experience?"
      : "Which of these can we improve on?";
  }
}
